import React from "react";

function WalletsV2Icon() {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.1199 10.7941C14.6501 10.7941 15.0799 10.3829 15.0799 9.87571C15.0799 9.36847 14.6501 8.95728 14.1199 8.95728C13.5897 8.95728 13.1599 9.36847 13.1599 9.87571C13.1599 10.3829 13.5897 10.7941 14.1199 10.7941Z"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 3.75268V13.8554C1 14.5318 1.576 15.08 2.28 15.08H15.72C16.4272 15.08 17 14.5318 17 13.8554V5.89568C17 5.21929 16.4272 4.67111 15.72 4.67111H1.96C1.43008 4.67111 1 4.25965 1 3.75529C1 3.30458 1.33984 2.93172 1.7872 2.85387L12.9296 1.02224C13.0056 1.00817 13.0827 1.00073 13.16 1C13.8672 1 14.44 1.54818 14.44 2.22458V4.67111"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default WalletsV2Icon;
